import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getCurrentMonthStartDate, getDDMMMYYDate, getUTCTimeStamp } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'

const responseParser = (res: any) => {
  if (res.data?.responseList) {
    return res.data.responseList
  } else {
    const code = res?.error?.code ?? '01'
    const message = res?.error?.message ?? 'An unexpected error has occoured'
    throw {
      code: code,
      message: message,
    }
  }
}

export const fetchTransactionHistory = (tokens: any, req: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.fetchTransactionHistory,
    method: 'POST',
    config: apiConfig(tokens),
    body: req,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((data) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return data
    })
    .catch((error) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: error,
      })
      throw error
    })
}

export const getTransactionHistoryRequest = (agentId: string) => {
  return {
    application: RootStore?.agent?.session?.CHANNEL_ID,
    initiatingEntityTimestamp: getUTCTimeStamp(),
    entityId: RootStore?.agent?.session?.CHANNEL_ID,
    agentId,
    //startDate:"6-Jul-2020",
    startDate: getDDMMMYYDate(getCurrentMonthStartDate()),
    endDate: getDDMMMYYDate(new Date()),
  }
}
